
const EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/im
const PHONE_REGEX = /1?\W*([2-9][0-8][0-9])\W*([2-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?/

/**
 * Users regexp to check if there is email-like text in the string
 * @param content
 */
export const containsEmail = (content: string): boolean => content.search(EMAIL_REGEX) !== -1

/**
 * Users regexp to check if there is a phone number in the string
 * @param content
 */
export const containsPhoneNumber = (content: string): boolean => content.search(PHONE_REGEX) !== -1

/**
 * Value can be a string or a number as long as it represents
 * a positive integer.
 *
 * @param value
 * @returns boolean - valid or not
 */
export const isPositiveInteger = (value: unknown): boolean => {
  const n = Number(value)
  return Number.isInteger(n) && n > 0
}

/**
 * Really just validating that it is a positive number.  Not verifying decimal places.
 * Can be a string or a number as long as it is a 0 or greater.
 * @param value - price
 * @returns boolean - valid or not
 */
export const isValidPrice = (value: unknown): boolean => {
  const n = Number(value)
  return !Number.isNaN(n) && n >= 0
}

/**
 * Checks to see if it is a valid currency value, ISO 4217.  If the browser
 * doesn't support the Intl.supportedValuesOf function, it will just verify
 * that it is characters long.
 *
 * @param value - currency value
 * @returns boolean - valid or not
 */
export const isValidCurrency = (value: unknown): boolean => {
  if (typeof value !== 'string') {
    return false
  }
  // checks to see if it is a valid currency value, ISO 4217
  if (typeof Intl['supportedValuesOf'] === 'function') {
    return Intl.supportedValuesOf('currency').indexOf(value.toUpperCase()) > -1
  }
  // that check is not supported, so opting to fallback to just making sure it is
  // 3 characters long
  return value.length === 3
}
